import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "../../../components/button";

interface IScanForm {
  loading: boolean;
  submit: any;
  form: UseFormReturn<any, any>;
}

export const CategoryForm: React.FC<IScanForm> = ({
  loading,
  submit,
  form,
}) => {
  return (
    <div className=" ">
      <div className="flex flex-wrap  -m-3 mb-2">
        <div className="w-full p-3">
          <p className="mb-1.5 font-medium text-base text-coolGray-800">Nom</p>
          <input
            className="w-full input"
            type="text"
            {...form.register("name", { required: "name required" })}
            placeholder="Nom"
          />
        </div>
      </div>

      <Button
        disabled={!form.formState.isValid}
        loading={loading}
        onClick={submit}
      >
        Valider
      </Button>
    </div>
  );
};
